// Campanha Inteligente nas telas de atendente (Delivery, Balcão, Totem, Mesas).
//
// Nelas o cliente costuma ser identificado DEPOIS dos itens entrarem no carrinho
// (no Totem o CPF vem na conferência). Por isso a oferta é aplicada nas linhas
// do carrinho quando o cliente aparece — e desfeita se ele mudar, se o dia virar
// ou se a oferta sair. O preço do produto na grade continua o normal: assim não
// existe risco de o desconto entrar duas vezes. Pizza fica de fora daqui: o
// popup de pizza já recebe as ofertas do cliente por tamanho.
import { unidadesDoItemNaOferta, unidadesPorChave } from "../promocoes";

const CAMPOS = ["oferta_chave", "oferta_dia", "oferta_desconto_unit", "oferta_desconto_pct", "oferta_cliente"];
const arred = (v) => Math.round(Number(v || 0) * 100) / 100;
// Cada tela soma e envia o pedido por um campo: `final_price` (Totem, Balcão,
// Mesas, venda rápida do Delivery) ou `sale_price` (popup "Novo pedido" do Delivery).
const precoDo = (it, campo) => Number(campo === "sale_price" ? it.sale_price ?? 0 : it.final_price ?? it.sale_price ?? 0);
const comPreco = (it, campo, valor) => (campo === "sale_price" ? { ...it, sale_price: valor } : { ...it, final_price: valor });

function aindaVale(it, ofertasDia, vigentes, clienteId) {
  const o = vigentes.get(it.oferta_chave);
  return !!o && it.oferta_cliente === clienteId && it.oferta_dia === ofertasDia.dia
    && Number(it.oferta_desconto_pct) === Number(o.pct);
}

function desfazer(it, campo) {
  const novo = comPreco(it, campo, arred(precoDo(it, campo) + Number(it.oferta_desconto_unit || 0)));
  CAMPOS.forEach((k) => { delete novo[k]; });
  return novo;
}

function marcaDaOferta(it, o, ofertasDia, clienteId, campo) {
  const combo = it.combo_type === "combo" && o.preco_combo;
  const unit = arred(combo ? o.preco_combo - o.preco_combo_oferta : o.preco_cheio - o.preco_oferta);
  if (unit <= 0) return null;
  return {
    oferta_chave: o.chave, oferta_dia: ofertasDia.dia, oferta_desconto_unit: unit,
    oferta_desconto_pct: o.pct, oferta_cliente: clienteId,
    [campo === "sale_price" ? "sale_price" : "final_price"]: arred(precoDo(it, campo) - unit),
  };
}

// `produtos` (opcional): cadastro, pra saber se a linha é quilo/litro quando o
// item do carrinho não traz sale_unit/is_divisible.
export function ajustarCarrinhoPdv(cart, ofertasDia, clienteId, campo = "final_price", produtos = null) {
  const estado = ofertasDia?.estado;
  if (!estado || estado === "carregando" || estado === "erro") return { cart, mudou: false };
  // Resposta de outro cliente (a troca ainda está carregando): não mexe em nada.
  if ((ofertasDia.paraCliente || null) !== (clienteId || null) && estado !== "desligada") return { cart, mudou: false };
  const vigentes = estado === "ativo" && clienteId ? ofertasDia.porChave : new Map();
  let mudou = false;
  const lista = (cart || []).map((it) => {
    if (!it.oferta_chave || aindaVale(it, ofertasDia, vigentes, clienteId)) return it;
    mudou = true;
    return desfazer(it, campo);
  });
  if (vigentes.size === 0) return { cart: lista, mudou };

  const limite = ofertasDia.config?.limite_unidades || 1;
  const usadas = unidadesPorChave(lista, produtos);
  const saida = [];
  for (const it of lista) {
    // Item que já veio de um pedido carimbado (oferta_id) nunca recebe outro desconto.
    const o = !it.oferta_chave && !it.oferta_id && !it.pizza && !it.pizza_meta ? vigentes.get(`p:${it.id}`) : null;
    const restante = o ? limite - (usadas[o.chave] || 0) : 0;
    const marca = o && restante > 0 ? marcaDaOferta(it, o, ofertasDia, clienteId, campo) : null;
    if (!marca) { saida.push(it); continue; }
    // Linha por quilo/litro conta 1 unidade: leva o desconto inteira, sem dividir
    const qtd = unidadesDoItemNaOferta(it, produtos) || 1;
    mudou = true;
    if (qtd <= restante) {
      saida.push({ ...it, ...marca });
      usadas[o.chave] = (usadas[o.chave] || 0) + qtd;
    } else {
      // Limite de unidades: a parte com oferta vira uma linha, o resto segue no preço normal.
      saida.push({ ...it, ...marca, quantity: restante, cartItemId: `${it.cartItemId || it.id}-oferta` });
      saida.push({ ...it, quantity: qtd - restante });
      usadas[o.chave] = limite;
    }
  }
  return { cart: saida, mudou };
}
